module.exports = __webpack_public_path__ + "a742a4d241244f74fb83872e4b659214.pdf";